import { render, staticRenderFns } from "./contactWiadvanceBulkEditDialog.vue?vue&type=template&id=388f43bb&lang=pug"
import script from "./contactWiadvanceBulkEditDialog.vue?vue&type=script&lang=js"
export * from "./contactWiadvanceBulkEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports